import JobApplicationFooter from './JobApplicationFooter.component';

export default JobApplicationFooter;